const firebaseConfig = {
    apiKey: "AIzaSyCeD1oG4P__uuvXdhUglBQYfk5wPudeWkY",
    authDomain: "wheels-point-motobike.firebaseapp.com",
    projectId: "wheels-point-motobike",
    storageBucket: "wheels-point-motobike.appspot.com",
    messagingSenderId: "908927418461",
    appId: "1:908927418461:web:e3ab06bd3f1e7325894db4",
    measurementId: "G-FQ23HX2BC8"
  };

  export default firebaseConfig;